export default {
	fontFamily: [
		'Hanimation Arabic',
		'Roboto',
		'"Helvetica Neue"',
		'Arial',
		'sans-serif',
	  ].join(','),
	h1: {
		fontSize: '2.5rem',
		fontWeight: 500
	},
	h2: {
		fontSize: '2rem',
		fontWeight: 500
	},
	h3: {
		fontSize: '1.75rem',
		fontWeight: 500
	},
	h4: {
		fontSize: '1.5rem',
		fontWeight: 500
	},
	h5: {
		fontSize: '1.25rem',
		fontWeight: 500
	},
	h6: {
		fontSize: '1rem',
		fontWeight: 500
	},
	body1: {
		fontSize: '1.25rem'
	},
	body2: {
		fontSize: '1rem'
	}
};
